import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import "../styles/Partnership.css";

export default function Partnership() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const partnershipCapabilities = [
    {
      number: "01",
      title: "Governance",
      description:
        "Connect specialist expertise with leadership, accountability, and organizational priorities.",
    },
    {
      number: "02",
      title: "Applied Research",
      description:
        "Translate academic and industry knowledge into practical occupational health and safety applications.",
    },
    {
      number: "03",
      title: "Digital Technology",
      description:
        "Explore responsible applications of engineering, automation, digital twins, AI, and emerging technology.",
    },
    {
      number: "04",
      title: "Immersive Learning",
      description:
        "Advance credible approaches to simulation, digital learning, and learning technology validation.",
    },
    {
      number: "05",
      title: "Evidence & Validation",
      description:
        "Strengthen how prevention evidence, outcomes, and implementation readiness are assessed.",
    },
    {
      number: "06",
      title: "Knowledge Exchange",
      description:
        "Create international networks that connect practical experience, research, and leadership insight.",
    },
  ];

  const focusAreas = [
    {
      id: "world-assembly",
      number: "01",
      // organization: "World Assembly",
      title: "Harmonizing Prevention-Focused Evidence and Metrics",
      status: "Peer Review",
      statusDescription:
        "International working group activity and proposed resource review.",
      role: "GESI Activity Lead",
      lead:
        "GESI is leading the Harmonizing Prevention-Focused Evidence and Metrics activity within the World Assembly’s global occupational health and safety initiative.",
      paragraphs: [
        "Led by Lisa McGuire, Founder and CEO of GESI, the activity brings together an international working group of occupational health and safety leaders, researchers, practitioners, and professional organizations to strengthen how prevention-focused evidence is defined, assessed, verified, and applied.",
        "The work focuses on identifying meaningful evidence and metrics, examining gaps in current practice, establishing guidance for evidence verification, and supporting peer review of proposed resources.",
        "The resulting guidance is intended to help organizations, practitioners, and leaders make better-informed decisions, evaluate whether prevention systems are working as intended, and strengthen continual improvement.",
      ],
      partners: [
        "What Works Institute",
        "Lloyd’s Register Foundation",
        "National Safety Council",
        "Institution of Occupational Safety and Health",
        "Asia Pacific Occupational Safety and Health Organization",
      ],
      themes: [
        "Serious-injury prevention",
        "Leadership and governance",
        "Psychological health and wellbeing",
        "Digital and operational security",
        "Evidence verification",
      ],
      cta: "Peer Reviewers Needed",
      link: "/contact",
      ctaNote:
        "Contact GESI to request current peer-review participation information.",
      logo: "/assets/C3.jpg",
      logoAlt: "World Assembly logo",
    },
    {
      id: "infacto-engineering",
      number: "02",
      // organization: "inFacto Engineering",
      title: "Human-Centric Digital Transformation",
      status: "Pilot Development",
      statusDescription:
        "Digital-twin exploration, engineering validation, and integration planning.",
      role: "Engineering Collaboration",
      lead:
        "GESI is working with inFacto Engineering to explore how engineering innovation, automation, digital twins, and emerging technologies can improve quality, operational, and occupational health and safety performance.",
      paragraphs: [
        "Together, the organizations examine practical applications that enhance decision-making, support safer work design, strengthen operational efficiency, and improve organizational resilience.",
        "Current collaboration focuses on digital-twin technology, engineering validation, digital-system integration, technical design, and implementation of emerging technologies through a human-centric approach integrated within an occupational health and safety system model.",
        "More information will be made available as additional implementation partners are integrated before the developing solution is introduced to industry sectors.",
      ],
      partners: [
        "GalaxyEDGE Safety Inc.",
        "inFacto Engineering",
        "Future implementation partners",
      ],
      themes: [
        "Digital twins",
        "Engineering validation",
        "System integration",
        "Human-centred design",
        "Practical workplace application",
      ],
      cta: "Request More Information",
      link: "/contact",
      ctaNote:
        "Request an overview of the current collaboration and development focus.",
      logo: "/assets/C2.jpg",
      logoAlt: "inFacto Engineering logo",
    },
    {
      id: "vsb-technical-university",
      number: "03",
      // organization: "VSB – Technical University of Ostrava",
      title: "Applied Research and Immersive Learning",
      status: "Consultation & Development",
      statusDescription:
        "Applied research, international collaboration, and task-force development.",
      role: "Academic Collaboration",
      lead:
        "GESI has a Memorandum of Understanding with VSB – Technical University of Ostrava to advance applied research, digital and immersive learning, occupational health and safety innovation, and international knowledge exchange.",
      paragraphs: [
        "The partnership connects academic research with industry practice to accelerate the development and evaluation of emerging learning technologies and integrated safety solutions.",
        "A key outcome of this collaboration is the continued development of the Global Digital & Immersive Learning Task Force.",
        "The Task Force supports international collaboration on the responsible evaluation, validation, and implementation of digital learning technologies for occupational health and safety.",
      ],
      partners: [
        "GalaxyEDGE Safety Inc.",
        "VSB – Technical University of Ostrava",
        "Global academic and industry contributors",
      ],
      themes: [
        "Applied research",
        "Immersive learning",
        "Technology evaluation",
        "International knowledge exchange",
        "Responsible implementation",
      ],
      cta: "Explore GDILTF",
      link: "/initiatives/digital-immersive-learning",
      ctaNote:
        "View the public purpose, current status, and approved Task Force information.",
      logo: "/assets/Vsb_logo_official.png",
      logoAlt: "VSB – Technical University of Ostrava logo",
    },
    {
      id: "what-works-institute",
      number: "04",
      // organization: "What Works Institute",
      title: "Strategic Advisory and Evidence-Informed Collaboration",
      status: "Active Collaboration",
      statusDescription:
        "Strategic advisory, knowledge exchange, and practitioner-led initiatives.",
      role: "GESI Strategic Advisor",
      lead:
        "GESI serves as Strategic Advisor to the What Works Institute, supporting collaborative initiatives that strengthen evidence-informed occupational health and safety leadership across industry sectors.",
      paragraphs: [
        "The partnership focuses on facilitating collaboration, sharing practical knowledge, and advancing initiatives that improve workplace health, safety, and organizational performance.",
        "Current collaboration includes support for the Canadian BioPharma EHS Leadership Forum.",
      ],
      partners: [
        "GalaxyEDGE Safety Inc.",
        "What Works Institute",
        "Industry practitioners",
        "EHS leadership networks",
      ],
      themes: [
        "Evidence-informed leadership",
        "Practical knowledge exchange",
        "Industry collaboration",
        "Leadership forums",
        "Organizational performance",
      ],
      cta: "Explore the Collaboration",
      link: "/contact",
      ctaNote:
        "Connect with GESI regarding collaborative initiatives and advisory support.",
      logo: "/assets/C1.jpg",
      logoAlt: "What Works Institute logo",
      forum: {
        status: "Exploratory",
        title: "Canadian BioPharma EHS Leadership Forum",
        subtitle: "A Practitioner-Led Forum for Complex EHS Challenges",
        description:
          "The proposed national forum would enable Canadian biopharma EHS professionals to exchange practical knowledge, strengthen regulatory awareness, and explore emerging workplace challenges.",
        role:
          "GESI supports the Forum as Strategic Advisor to the What Works Institute.",
        // link: "/initiatives/biopharma-ehs-forum",
        // cta: "Learn More About the Forum",
      },
    },
  ];

  return (
    <main className="partnerships-page">
      {/* PAGE HERO */}
      <section
        className="partnerships-hero"
        aria-labelledby="partnerships-hero-title"
      >
        <div className="partnerships-hero-background" aria-hidden="true">
          <span className="partnerships-hero-glow partnerships-glow-left"></span>
          <span className="partnerships-hero-glow partnerships-glow-right"></span>

          <span className="partnerships-orbit partnerships-orbit-one"></span>
          <span className="partnerships-orbit partnerships-orbit-two"></span>
          <span className="partnerships-orbit partnerships-orbit-three"></span>

          <span className="partnerships-network-line partnerships-network-one"></span>
          <span className="partnerships-network-line partnerships-network-two"></span>
        </div>

        <div className="partnerships-hero-container">
          <p className="partnerships-kicker">
            Partnerships &amp; Initiatives
          </p>

          <h1
            id="partnerships-hero-title"
            className="partnerships-hero-title"
          >
            Collaboration That Expands
            <span> What Is Possible.</span>
          </h1>

          <p className="partnerships-hero-description">
            GESI believes meaningful innovation happens through collaboration.
            By bringing together engineering, academia, industry, professional
            organizations, and international networks, we help transform
            emerging ideas into practical solutions that strengthen
            occupational health and safety performance.
          </p>

          <a
            href="#collaboration-focus"
            className="partnerships-primary-button"
          >
            <span>Explore Collaboration</span>

            <span
              className="partnerships-button-arrow"
              aria-hidden="true"
            >
              ↓
            </span>
          </a>

          <div
            className="partnerships-hero-network"
            aria-label="GESI collaboration network"
          >
            <span>Engineering</span>
            <span aria-hidden="true">+</span>
            <span>Academia</span>
            <span aria-hidden="true">+</span>
            <span>Industry</span>
            <span aria-hidden="true">+</span>
            <span>Global Networks</span>
          </div>
        </div>
      </section>

      {/* INTRODUCTION */}
      <section
        className="partnerships-introduction"
        aria-labelledby="partnerships-introduction-title"
      >
        <div className="partnerships-introduction-container">
          <div className="partnerships-introduction-heading">
            <p className="partnerships-section-kicker">
              A Connected Delivery Model
            </p>

            <h2
              id="partnerships-introduction-title"
              className="partnerships-section-title"
            >
              Partnership as a
              <span> Delivery Capability</span>
            </h2>
          </div>

          <div className="partnerships-introduction-copy">
            <p>
              Complex safety challenges cannot be solved through one
              discipline or one organization.
            </p>

            <p>
              GESI builds focused collaborations that connect the right
              expertise to governance, applied research, digital technology,
              immersive learning, validation, and international knowledge
              exchange.
            </p>
          </div>

          <div className="partnerships-capability-grid">
            {partnershipCapabilities.map((capability) => (
              <article
                className="partnerships-capability-card"
                key={capability.title}
              >
                <span className="partnerships-capability-number">
                  {capability.number}
                </span>

                <h3>{capability.title}</h3>
                <p>{capability.description}</p>

                <span
                  className="partnerships-capability-line"
                  aria-hidden="true"
                ></span>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* FOCUS AREAS */}
      <section
        id="collaboration-focus"
        className="partnerships-focus"
        aria-labelledby="partnerships-focus-title"
      >
        <div className="partnerships-focus-background" aria-hidden="true"></div>

        <div className="partnerships-focus-container">
          <header className="partnerships-centered-heading">
            <p className="partnerships-section-kicker">
              Current Collaboration
            </p>

            <h2
              id="partnerships-focus-title"
              className="partnerships-section-title"
            >
              Focused Partnerships with
              <span> Practical Purpose</span>
            </h2>

            <p>
              Each collaboration brings together defined expertise, a clear
              public purpose, and a responsible pathway from exploration to
              practical application.
            </p>
          </header>

          <div className="partnership-pdf-link">
            <a
              href="/assets/Form1.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="partnership-pdf-label">
                View Peer review interest form
              </span>

              <span
                className="partnership-pdf-arrow"
                aria-hidden="true"
              >
                ↗
              </span>
            </a>
          </div>

          <div className="partnerships-focus-list">
            {focusAreas.map((area, index) => (
              <article
                id={area.id}
                className={`partnerships-focus-item ${
                  index % 2 !== 0
                    ? "partnerships-focus-item-reverse"
                    : ""
                }`}
                key={area.id}
              >
                <div className="partnerships-focus-visual">
                  <span
                    className="partnerships-focus-visual-orbit"
                    aria-hidden="true"
                  ></span>

                  <div className="partnerships-focus-mark">
                    <img
                      src={area.logo}
                      alt={area.logoAlt}
                      className="partnerships-focus-logo"
                      loading="lazy"
                    />
                  </div>

                  <span className="partnerships-focus-number">
                    {area.number}
                  </span>

                  <div className="partnerships-focus-status">
                    <span aria-hidden="true"></span>
                    {area.status}
                  </div>

                  <p>{area.organization}</p>
                </div>

                <div className="partnerships-focus-content">
                  <div className="partnerships-focus-meta">
                    <div>
                      <p className="partnerships-focus-role">
                        {area.role}
                      </p>

                      <span>{area.statusDescription}</span>
                    </div>

                    <span
                      className="partnerships-focus-index"
                      aria-hidden="true"
                    >
                      {area.number}
                    </span>
                  </div>

                  <h3>{area.title}</h3>

                  <p className="partnerships-focus-lead">
                    {area.lead}
                  </p>

                  <div className="partnerships-focus-paragraphs">
                    {area.paragraphs.map((paragraph) => (
                      <p key={paragraph}>{paragraph}</p>
                    ))}
                  </div>

                  <div className="partnerships-focus-details">
                    <div>
                      <p className="partnerships-focus-detail-label">
                        Collaboration network
                      </p>

                      <ul className="partnerships-partner-list">
                        {area.partners.map((partner) => (
                          <li key={partner}>
                            <span aria-hidden="true"></span>
                            {partner}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div>
                      <p className="partnerships-focus-detail-label">
                        Current themes
                      </p>

                      <div className="partnerships-theme-list">
                        {area.themes.map((theme) => (
                          <span key={theme}>{theme}</span>
                        ))}
                      </div>
                    </div>
                  </div>

                  {area.forum && (
                    <aside className="partnerships-forum">
                      <div className="partnerships-forum-header">
                        <div>
                          <p>Featured Initiative</p>

                          <span className="partnerships-forum-status">
                            <span aria-hidden="true"></span>
                            {area.forum.status}
                          </span>
                        </div>

                        <span aria-hidden="true">CBF</span>
                      </div>

                      <h4>{area.forum.title}</h4>

                      <strong>{area.forum.subtitle}</strong>

                      <p>{area.forum.description}</p>
                      <p>{area.forum.role}</p>

                      {area.forum.link && area.forum.cta && (
                        <NavLink
                          to={area.forum.link}
                          className="partnerships-forum-link"
                        >
                          <span>{area.forum.cta}</span>
                          <span aria-hidden="true">↗</span>
                        </NavLink>
                      )}
                    </aside>
                  )}

                  <div className="partnerships-focus-action">
                    <div>
                      <span>Current public action</span>
                      <p>{area.ctaNote}</p>
                    </div>

                    {/* <NavLink
                      to={area.link}
                      className="partnerships-focus-button"
                    >
                      <span>{area.cta}</span>

                      <span
                        className="partnerships-focus-button-arrow"
                        aria-hidden="true"
                      >
                        ↗
                      </span>
                    </NavLink> */}
                  </div>

                  <span
                    className="partnerships-focus-bottom-line"
                    aria-hidden="true"
                  ></span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* PUBLICATION AND STATUS CONTROLS */}
      {/* <section
        className="partnerships-controls"
        aria-labelledby="partnerships-controls-title"
      >
        <div className="partnerships-controls-background" aria-hidden="true">
          <span className="partnerships-controls-glow"></span>
        </div>

        <div className="partnerships-controls-container">
          <div className="partnerships-controls-content">
            <p className="partnerships-section-kicker">
              Clear Public Status
            </p>

            <h2
              id="partnerships-controls-title"
              className="partnerships-section-title"
            >
              Transparent Initiative
              <span> Information</span>
            </h2>

            <p>
              Dedicated initiative pages will identify their current status,
              public purpose, approved outputs, relevant action, version or
              date, and last-updated information.
            </p>
          </div>

          <div className="partnerships-status-language">
            <p>Approved public status language</p>

            <div>
              <span>Exploratory</span>
              <span>Consultation</span>
              <span>Pilot Development</span>
              <span>Peer Review</span>
              <span>In Validation</span>
              <span>Approved</span>
              <span>Published</span>
            </div>

            <aside>
              Internal workplans, confidential reports, and unapproved findings
              remain outside the public website.
            </aside>
          </div>
        </div>
      </section> */}

      {/* FINAL CTA */}
      <section
        className="partnerships-final"
        aria-labelledby="partnerships-final-title"
      >
        <div className="partnerships-final-background" aria-hidden="true">
          <span className="partnerships-final-glow"></span>
          <span className="partnerships-final-orbit"></span>
        </div>

        <div className="partnerships-final-container">
          <p className="partnerships-section-kicker">
            Build Something Together
          </p>

          <h2
            id="partnerships-final-title"
            className="partnerships-final-title"
          >
            Connect the Right Expertise to
            <span> a Meaningful Safety Challenge.</span>
          </h2>

          <p className="partnerships-final-description">
            GESI works with organizations that bring credible expertise,
            practical insight, research capability, engineering knowledge, or
            a shared commitment to strengthening occupational health and
            safety outcomes.
          </p>

          <NavLink
            to="/contact"
            className="partnerships-primary-button"
          >
            <span>Explore Collaboration</span>

            <span
              className="partnerships-button-arrow"
              aria-hidden="true"
            >
              ↗
            </span>
          </NavLink>
        </div>
      </section>
    </main>
  );
}